import React, { useEffect } from 'react';
import { CheckCircle } from 'lucide-react';
import { useFlow } from '../../../contexts/FlowContext';
import { useTheme, useMessages } from '../../../contexts/ThemeContext';
import SessionExpiryModal from '../../../components/modals/SessionExpiryModal';

const SuccessPage: React.FC = () => {
  const { getFlowData } = useFlow();
  const { theme } = useTheme();
  const messages = useMessages();
  
  const newUsername = getFlowData('newUsername') || '';

  useEffect(() => {
    const relayState = sessionStorage.getItem('samlRelayState');
    let redirectUrl = 'https://google.com';
    
    if (relayState) {
      const separator = redirectUrl.includes('?') ? '&' : '?';
      redirectUrl += `${separator}RelayState=${encodeURIComponent(relayState)}`;
    }
    
    const timer = setTimeout(() => {
      window.location.href = redirectUrl;
    }, 3000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="container">
      <CheckCircle 
        size={64} 
        className="icon" 
        style={{ 
          color: theme.colors?.success || '#28a745', 
          marginBottom: theme.spacing?.lg || '1.5rem' 
        }} 
      />
      
      <h1>{messages.ui?.usernameChange?.successMessage || 'Username Updated Successfully!'}</h1>
      
      <div style={{
        backgroundColor: theme.components?.alert?.success?.backgroundColor || '#d4edda',
        border: `1px solid ${theme.components?.alert?.success?.borderColor || '#c3e6cb'}`,
        color: theme.components?.alert?.success?.color || '#155724',
        borderRadius: theme.borderRadius?.md || '8px',
        padding: theme.spacing?.lg || '1.5rem',
        marginBottom: theme.spacing?.lg || '1.5rem',
        textAlign: 'center'
      }}>
        <p style={{ margin: 0, fontSize: '1.1rem' }}>
          Your new username is: <strong>{newUsername}</strong>
        </p>
      </div>

      <p style={{ 
        color: theme.colors?.textMuted || '#6c757d',
        fontSize: theme.typography?.fontSize?.sm || '0.875rem'
      }}>
        Redirecting you back to the application...
      </p>
      <SessionExpiryModal />
    </div>
  );
};

export default SuccessPage;
